import { Box, Container, Typography } from '@mui/material';
import { useSearchParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { APP_ENDPOINT } from '../../shared/constans';
import { EventAfterTip } from './EventAfterTip';
import {
  useValidateStripeSessionMutation,
  ValidateStripeSessionResponse,
} from '../../shared/types/generated';

export const TipsAppreciation: React.FC = () => {
  const [searchParams] = useSearchParams();
  const [alreadyChecked, setAlreadyChecked] = useState(false);
  const [session, setSession] = useState<
    undefined | ValidateStripeSessionResponse | null
  >(undefined);
  const sessionId = searchParams.get('session_id') || '';

  const [callValidate] = useValidateStripeSessionMutation({
    onCompleted: (r) => {
      console.log(r.validateStripeSession);
      setSession(r.validateStripeSession);
      setAlreadyChecked(true);
    },
    onError: () => {
      console.log('hubo un error al recuperar la sesion de compra');
      //window.location.href = DOMAIN_SITE_URL;
    },
  });

  useEffect(() => {
    if (sessionId) {
      callValidate({
        variables: {
          data: {
            sessionId,
          },
        },
      });
    }
  }, [sessionId, callValidate]);
  if (!sessionId || !alreadyChecked) {
    return null;
  }

  return (
    <div>
      <>
        {session ? (
          <EventAfterTip
            ammount={((session?.amount_total || 1) / 100).toFixed(2).toString()}
            session_id={sessionId}
            user={{
              id: 0,
              name: session.customer_details?.name || '',
              email: session.customer_details?.email || '',
            }}
          />
        ) : null}
      </>
      <Box paddingY={5}>
        <Container maxWidth={'sm'}>
          <Box
            display={'flex'}
            justifyContent={'center'}
            paddingX={2}
            marginBottom={{ xs: '60px', sm: '100px' }}
          >
            <div>
              <Typography
                fontFamily={'oswald'}
                fontWeight={700}
                fontSize={{ xs: 17, sm: 28 }}
                lineHeight={{ xs: '22px', sm: '33px' }}
              >
                ¡GRACIAS POR CREER EN
              </Typography>
              <Typography
                fontFamily={'oswald'}
                fontWeight={700}
                fontSize={{ xs: 17, sm: 28 }}
                color={'#FC1206'}
                lineHeight={{ xs: '22px', sm: '33px' }}
              >
                EL PERIODISMO LIBRE!
              </Typography>
            </div>
          </Box>
          <Box display={'flex'} justifyContent={'center'}>
            <Box
              width={{ xs: '100%', sm: '511px' }}
              sx={{ background: '#f0f0f0' }}
              paddingX={{ xs: '10px', lg: '30px' }}
              paddingY={{ xs: '45px', lg: '30px' }}
              marginBottom={'34px'}
              position={'relative'}
            >
              <Box
                component={'img'}
                height={'84px'}
                width={'84px'}
                position={'absolute'}
                top={-42}
                right={20}
                src={'/apreciate.png'}
                alt="tipo de suscripción"
              />
              <Typography
                fontFamily={'oswald'}
                textTransform={'uppercase'}
                fontSize={28}
                color={'#FC1206'}
                lineHeight={'33px'}
                textAlign={'center'}
              >
                {session?.customer_details?.name}Prueba:
              </Typography>
              <Box display={'flex'} justifyContent={'center'}>
                <Box paddingTop={2} width={{ sx: '100%', sm: '311px' }}>
                  <Typography textAlign={'center'} fontFamily={'manop'}>
                    Tu aportación nos impulsa a seguir contando historias que
                    merecen ser escuchadas.
                  </Typography>
                </Box>
              </Box>
            </Box>
          </Box>
          <Box display={'flex'} justifyContent={'center'}>
            <a href={APP_ENDPOINT} style={{ textDecoration: 'none' }}>
              <Box
                paddingX={'22px'}
                paddingY={'16px'}
                borderRadius={'33px'}
                sx={{ background: '#FC1206' }}
              >
                <Typography
                  fontFamily={'oswald'}
                  textTransform={'uppercase'}
                  lineHeight={'16px'}
                  color={'white'}
                >
                  Disfruta de nuestros contenidos
                </Typography>
              </Box>
            </a>
          </Box>
        </Container>
      </Box>
    </div>
  );
};
